import { env } from '@/config/env'
import { SpSurveyPath } from './sp-survey-paths'

/**
 * Sensemaker draft stores private-bucket media at
 * `/api/v1/instruments/:id/draft/option-images/:optionId` (or campaign-scoped variant)
 * and `/api/v1/instruments/:id/draft/question-videos/:questionId`.
 * SP surveys must use the provider-authenticated serve routes instead.
 */
const DRAFT_OPTION_IMAGE_RE =
  /\/api\/v1\/(?:campaigns\/[^/]+\/)?instruments\/([^/]+)\/draft\/option-images\/([^/?#]+)/i

const SP_OPTION_IMAGE_RE =
  /\/api\/v1\/sp\/instruments\/([^/]+)\/option-images\/([^/?#]+)/i

const DRAFT_QUESTION_VIDEO_RE =
  /\/api\/v1\/(?:campaigns\/[^/]+\/)?instruments\/([^/]+)\/draft\/question-videos\/([^/?#]+)/i

const SP_QUESTION_VIDEO_RE =
  /\/api\/v1\/sp\/instruments\/([^/]+)\/question-videos\/([^/?#]+)/i

function rewriteDraftMediaPath(pathname: string): string | null {
  const image = DRAFT_OPTION_IMAGE_RE.exec(pathname)
  if (image) return SpSurveyPath.optionImage(image[1], image[2])
  const video = DRAFT_QUESTION_VIDEO_RE.exec(pathname)
  if (video) return SpSurveyPath.questionVideo(video[1], video[2])
  return null
}

function isSpMediaPath(pathname: string): boolean {
  return SP_OPTION_IMAGE_RE.test(pathname) || SP_QUESTION_VIDEO_RE.test(pathname)
}

function prefixApiBase(path: string): string {
  const base = env.VITE_API_BASE_URL.replace(/\/$/, '')
  return base ? `${base}${path}` : path
}

/** Resolve option image / question video URLs from campaign draft (absolute, or API serve path). */
export function resolveSurveyMediaUrl(imageUrl: string | null | undefined): string | null {
  if (!imageUrl?.trim()) return null
  const trimmed = imageUrl.trim()

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const url = new URL(trimmed)
      const rewritten = rewriteDraftMediaPath(url.pathname)
      if (rewritten) {
        return prefixApiBase(rewritten)
      }
      if (isSpMediaPath(url.pathname)) {
        return prefixApiBase(`${url.pathname}${url.search}`)
      }
    } catch {
      return trimmed
    }
    return trimmed
  }

  if (trimmed.startsWith('/')) {
    const rewritten = rewriteDraftMediaPath(trimmed)
    return prefixApiBase(rewritten ?? trimmed)
  }

  return trimmed
}
